import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import AuditTrailSearch from '../../components/AuditTrail/AuditTrailSearch/AuditTrailSearch';
import AuditTrailTable from '../../components/AuditTrail/AuditTrailTable/AuditTrailTable';
import Alert from '../../components/UI/Alert/Alert';
import Container from '../../components/UI/Container/Container';
import Spinner from '../../components/UI/Spinner/Spinner';
import { IAppState, IAuditTrailState } from '../../interfaces';
import * as actions from '../../store/actions';
import { ETranslation } from '../../translations/translation-keys';

interface IProps extends RouteComponentProps {
}

const AuditTrails: React.FC<IProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { loading, error, auditTrails } = useSelector<IAppState, IAuditTrailState>(state => state.auditTrail);

  const searchHandler = useCallback((search: any) => {
    dispatch(actions.listAuditTrails(search));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(actions.clearAuditTrails());
    };
  }, [dispatch]);

  return (
    <Container>
      {error && <Alert>{t(error)}</Alert>}
      <h2>{t(ETranslation.AUDIT_TRAIL)}</h2>
      <AuditTrailSearch onSearch={searchHandler} />
      {loading ? (
        <Spinner />
      ) : auditTrails ? (
        auditTrails.length > 0 ? (
          <AuditTrailTable
            auditTrails={auditTrails}
            sortable
          />
        ) : (
          <p>
            <br />
            {t(ETranslation.AUDIT_TRAIL_NO_ITEMS)}
          </p>
        )
      ) : null}
    </Container>
  );
};

export default AuditTrails;